import type { Response } from 'ts-retrofit3';
import { BaseService, Body, ExtraMap, GET, Header, PATCH, Path, POST, PUT, Signal } from 'ts-retrofit3';

import type { IExtra } from '@/Module/Core/Model/ApiModel';
import { EXAM_API } from '@/Module/Exam/Constant';
import type { IExamAnswerRequest, IExamFinishResponse, IExamStartResponse } from '@/Module/Exam/Model/ApiModel';
import type { IExam, IExamQuestion, IExamUserExamAnswer } from '@/Module/Exam/Model/DataModel';

import ExamHttpService from './ExamHttpService';

class ExamService extends BaseService {
  @GET(EXAM_API.GET_EXAM_BY_CONTENT_ID)
  async getExamByContentId(
    @Path('contentId') _contentId: IExam['id'],
    @Header('Authorization') _authorization: string,
    @ExtraMap _extra?: IExtra,

    @Signal _signal?: AbortSignal,
  ): Promise<Response<IExam>> {
    return <Response>{};
  }

  @POST(EXAM_API.START_EXAM)
  async startExam(
    @Path('id') _examId: IExam['id'],
    @Header('Authorization') _authorization: string,
    @Signal _signal?: AbortSignal,
  ): Promise<Response<IExamStartResponse>> {
    return <Response>{};
  }

  @PATCH(EXAM_API.FINISH_EXAM)
  async finishExam(
    @Path('id') _examId: IExam['id'],
    @Header('Authorization') _authorization: string,
    @Signal _signal?: AbortSignal,
  ): Promise<Response<IExamFinishResponse>> {
    return <Response>{};
  }

  @PATCH(EXAM_API.CANCEL_EXAM)
  async cancelExam(
    @Path('id') _examId: IExam['id'],
    @Header('Authorization') _authorization: string,
    @Signal _signal?: AbortSignal,
  ): Promise<Response<IExamFinishResponse>> {
    return <Response>{};
  }

  @PATCH(EXAM_API.RESULT_EXAM)
  async resultExam(
    @Path('id') _examId: IExam['id'],
    @Header('Authorization') _authorization: string,
    @Signal _signal?: AbortSignal,
  ): Promise<Response<IExamFinishResponse>> {
    return <Response>{};
  }

  @GET(EXAM_API.GET_EXAM_QUESTION_LIST)
  async getExamQuestionList(
    @Path('id') _examId: IExam['id'],
    @Header('Authorization') _authorization: string,
    @Signal _signal?: AbortSignal,
  ): Promise<Response<IExamQuestion[]>> {
    return <Response>{};
  }

  @PUT(EXAM_API.ANSWER_EXAM_QUESTION)
  async answerExamQuestion(
    @Path('id') _examId: IExam['id'],
    @Path('questionId') _examQuestionId: IExamQuestion['id'],
    @Header('Authorization') _authorization: string,
    @Body _body: IExamAnswerRequest,
    @Signal _signal?: AbortSignal,
  ): Promise<Response<IExamUserExamAnswer>> {
    return <Response>{};
  }
}

export default ExamHttpService.build(ExamService);
